import { OldIconName } from '../helpers/types/footer'
import { getFooterIcon } from '../helpers/utils/getFooterIcon'

import Section from '@/components/atomic/molecules/Section'
import { IconPack } from '@/components/cell/atoms/Icon/enum'

interface IconLink {
  name: IconPack | OldIconName
  url: string
  'aria-label'?: string
}

interface Props {
  iconLink: IconLink[]
  onWeChatClick: () => void
}

const SocialIcons = ({ iconLink, onWeChatClick }: Props) => {
  return (
    <Section padding={0} hasDivider={false} className="my-[12px] [&_a]:text-[#888888]">
      <div className="flex flex-wrap gap-2.5">
        {iconLink
          .filter((item) => {
            return item.url && item.url.trim() !== ''
          })
          .map((item, index) => {
            // 위챗은 모달로 표시
            if (item.name === 'wechat') {
              return (
                <button
                  key={`icon_${index}`}
                  type="button"
                  onClick={onWeChatClick}
                  aria-label={item['aria-label'] ?? 'WeChat'}
                  className="bg-transparent border-0 p-0 cursor-pointer"
                >
                  {getFooterIcon(item.name)}
                </button>
              )
            }
            return (
              <a key={`icon_${index}`} href={item.url} target="_blank" rel="noreferrer" aria-label={item['aria-label']}>
                {getFooterIcon(item.name)}
              </a>
            )
          })}
      </div>
    </Section>
  )
}

export default SocialIcons
